/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPlatformClient} from '../api'

 export const useQueryGetPlatformClient = createReactQueryHook('getPlatformClient', getPlatformClient)
